
    <div class="col-sm-4 form-group">
        <h1>Logout</h1>
        <p>You have been successfully logged out.</p>
    </div>